import type { AppointmentTypeDto } from '@shared/core/appointment-types'
import type { BookingData } from './booking-wrapper.interface'

/** Pins the selected type's questions on first entry; keeps the pin and answers while the type is unchanged. */
export function pinBookingForm(data: BookingData, appointmentTypes: AppointmentTypeDto[]): BookingData {
  const appointmentTypeId = data.appointmentType
  if (!appointmentTypeId || data.bookingForm?.appointmentTypeId === appointmentTypeId) return data
  const appointmentType = appointmentTypes.find((type) => type.id === appointmentTypeId)
  if (!appointmentType) return { ...data, bookingForm: undefined, answers: {} }
  return {
    ...data,
    bookingForm: {
      appointmentTypeId,
      questions: [...(appointmentType.booking_questions ?? [])],
      revision: appointmentType.booking_questions_revision ?? 0,
    },
    answers: {},
  }
}
